var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({staticClass:"white--text",attrs:{"icon":"","color":_vm.color}},'v-btn',_vm.$attrs,false),_vm.inputListeners),[_c('v-icon',{attrs:{"large":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }